import { Grid, Filter, Page, Sort, Edit, Toolbar } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { DateHelper } from '../../Helpers/DateHelper';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { ErrorSources } from '../../Models/Admin/ErrorSources';
import { ErrorPriority } from '../../Models/Admin/ErrorPriority';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';

export class ErrorLogManager {

    constructor(private containerElement: JQuery) { }

    private errorLogGrid : Grid;   

    private errorLogItemPopup : ModalHelper; 

    public initialize() {
        var self = this;

        Grid.Inject(Edit, Toolbar, Filter, Page, Sort);

        self.initializeErrorLogsTable();
    }

    private initializeErrorLogsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var errorLogsTableContainer = self.containerElement.find('#error-logs-table-container');

        var erpGridElement : JQuery<HTMLElement> = self.containerElement.find('#ErrorLogsGrid');
        var erpContentElement : JQuery<HTMLElement> = erpGridElement;

        this.errorLogItemPopup = new ModalHelper();
        this.errorLogItemPopup.createModal("error-log-info-popup", true);

        var creationDateElem;
        var creationDateObj;

        let erpData: DataManager = new DataManager({
            url: '/api/company/lookup/errors',
            adaptor: new WebApiAdaptor
        });

        self.errorLogGrid = new Grid(
        {
            height: '100%',
            dataSource: erpData,
            editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
            columns: [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},  
                { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, allowFiltering: true,
                    filterBarTemplate: {
                        create: () => { 
                            creationDateElem = document.createElement('input'); 
                            return creationDateElem; 
                        }, 
                        write: (args) => {
                            const persistedValue =
                                args?.value
                                ?? self.errorLogGrid?.filterSettings?.columns
                                    ?.find((x: any) => x.field === 'CreationDateTimeString')
                                    ?.value;

                            creationDateObj = new DatePicker({
                                value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                format: 'dd-MM-yyyy',
                                floatLabelType: 'Never',

                                change: (args) => {
                                    const dateValue = DateHelper.DateToString(args.value);

                                    if (dateValue == undefined) {
                                        self.errorLogGrid.removeFilteredColsByField(
                                            'CreationDateTimeString'
                                        );
                                    } else {
                                        self.errorLogGrid.filterByColumn(
                                            'CreationDateTimeString',
                                            'equal',
                                            dateValue,
                                            undefined,
                                            true
                                        );
                                    }
                                }
                            });
                            creationDateObj.appendTo(creationDateElem); 
                        } 
                    }, width: '125px', validationRules: { required: true }},
                { field: 'ErrorSource', allowSorting: false, headerText: 'Source', autoFit: true,allowFiltering: true, width: 125,
                    filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.errorLogGrid,'ErrorSource', Object.keys(ErrorSources).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.errorLogGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    } else {
                        self.errorLogGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                    }
                    })
                },
                { field: 'ErrorPriority', allowSorting: false, headerText: 'Priority', autoFit: true,allowFiltering: true, width: 100,
                    filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.errorLogGrid,'ErrorPriority', Object.keys(ErrorPriority).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.errorLogGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    } else {
                        self.errorLogGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                    }
                    })
                },
                { field: 'Message1', headerText: 'Message 1', allowFiltering: true, autoFit: true, validationRules: { required: false }, allowSorting: false},
                { field: 'Message2', headerText: 'Message 2', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: false},
                { field: 'AdditionalInfo', headerText: 'Additional info', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: false},
            ],
            allowSorting: true,
            allowPaging: true,
            allowFiltering: true,
            allowSelection: false,
            enablePersistence: true,
            toolbarTemplate: '#toolbar-template',
            pageSettings: { pageSize: 100 },
            created: () => {
                erpContentElement = erpContentElement.find('.e-content')

                loadingContainer.addClass('d-none');
                errorLogsTableContainer.removeClass('d-none');

            },
            actionBegin: (args) => {
                if (!this.errorLogGrid) {
                    return;
                }

                if (SyncfusionGridHelper.isFilterAction(args)) {
                    this.errorLogGrid.pageSettings.currentPage = 1;
                }
            },
            recordDoubleClick: (e) => {
                self.errorLogItemPopup.load(`?errorLogItemId=${e.rowData.Id}&handler=ErrorLogItemInfo`);
                return;
            }
        });

        self.errorLogGrid.appendTo('#ErrorLogsGrid');
        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.errorLogGrid.pageSettings.currentPage = 1;
                self.errorLogGrid.clearFiltering();
                self.errorLogGrid.refreshHeader();
            })
        }
    }
}